import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';

export default async function asSingleHistoryEntry<T>(task: () => Promise<T> | T): Promise<T> {
	const history = currentEditorStore.get.history;

	history.beginGroup();

	try {
		return await task();
	} finally {
		history.endGroup();
	}
}
